import ArgType, {withErrorsAllowed} from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import flatten from 'notebook/tables/excess/util/flatten';

export default {
  name: 'ISBLANK',
  category: FunctionCategory.LOGIC,
  shortDescription: 'Checks whether the referenced cell is empty.',
  description: 'Checks whether the referenced cell is empty.',
  params: [
    {
      name: 'value',
      type: withErrorsAllowed(ArgType.any),
      description: 'The cell or range that will be checked for emptiness.',
    },
  ],
  eval: (...operands): boolean => {
    operands = flatten(operands);
    return operands.every((x) => x === '' || x == null);
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;
